"use client";
import Be from "openai";
import { useState as c, useRef as P, useEffect as ae, useImperativeHandle as De } from "react";
import { useInkeepConfig as Oe } from "../../providers/config-provider.js";
import { useInkeepConversation as Re } from "../../providers/conversation-provider.js";
import { useChatEvents as Pe } from "../../providers/chat-events-provider.js";
import { getMessageMetadata as Ue, serializeAttachments as Fe, serializeWorkflow as Ke } from "../../utils/get-message-metadata.js";
import { parseIfJson as We } from "../../utils/misc.js";
import { resetQueryParams as re } from "../../utils/reset-query-params.js";
import { useChatForm as Je } from "../../providers/chat-form-provider.js";
import { useWidget as Te } from "../../providers/widget-provider.js";
import { useMediaQuery as ze } from "../../hooks/use-media-query.js";
import { useCaptcha as He } from "./use-captcha.js";
import { useModal as Qe } from "../modal/modal-provider.js";
import { generateUid as u } from "../../utils/generate-uid.js";
import { provideLinksTool as je } from "../../utils/tools/links-tool.js";
import { getConversation as qe } from "../../atoms/api/analytics/conversation.js";
const mt = () => {
  const { chatId: d, setConversation: ie, conversation: U, resetConversation: ce } = Re(), { baseSettings: k, aiChatSettings: F } = Oe(), { aiApiBaseUrl: K, shouldBypassCaptcha: W, filters: J } = k, T = Qe(), { getSolution: le, prefetchSolution: b, invalidateSolution: z } = He({
    fetchUrl: `${K}/v1/challenge`,
    shouldBypassCaptcha: W,
    shouldMakeInitialRequest: T ? T.isOpen : !0
  }), ue = new Be({
    baseURL: `${K}/v1`,
    apiKey: k.apiKey,
    dangerouslyAllowBrowser: !0
  }), { onInputMessageChange: me, getTools: ge, prompts: pe, model: de, filters: H } = F, [f, x] = c(""), Q = P(null);
  ae(() => {
    me?.(f);
  }, [f]);
  const [m, l] = c([]), [j, h] = c(!1), [fe, y] = c(!1), [he, q] = c(null), [L, G] = c(null), [C, w] = c([]), ye = (e) => {
    w((t) => [...t, e]);
  }, [Ce, V] = c({}), r = P([]), v = P(null), { logEvent: $ } = Pe(), X = pe?.map((e, t) => ({
    id: `system-${Date.now().toString()}-${u(4)}-${t}`,
    role: "system",
    content: e
  })), [we, ve] = c(!!d);
  ae(() => {
    if (d) {
      const { apiKey: e, analyticsApiBaseUrl: t } = k;
      qe(d, e, t).then((s) => {
        if (s) {
          $({
            eventName: "shared_chat_loaded",
            properties: {
              conversation: s
            }
          }), ve(!1), ie({ ...s, id: "" });
          const o = s.messages.map((i) => ({
            id: Date.now().toString() + u(4) + i.id,
            content: We(i.content),
            role: i.role,
            links: i.links
          }));
          l(o), r.current = o;
        }
      });
    }
  }, [d]);
  const Ie = (e) => {
    switch (e.code) {
      case 400:
        return e.message;
      case 403:
        return `There seems to be a configuration error. Please contact ${k.organizationDisplayName ?? "Administrator"}`;
      default:
        return `Hmm.. 

It seems I might be having some issues right now. Please clear the chat and try again.`;
    }
  }, Y = (e) => {
    q(e), l((t) => {
      const s = [...t], o = s[s.length - 1];
      return o && (o.content = Ie(e)), s;
    }), h(!1), y(!1), z(), b();
  }, B = !f.trim() && !C.length || j, Me = (e) => {
    e.key === "Enter" && !e.shiftKey && !B && !e.nativeEvent.isComposing && (e.preventDefault(), D());
  }, Se = (e) => {
    const t = e.target.value;
    x(t);
  }, D = async (e = f) => {
    if (B && (!e || e.trim().length === 0)) return;
    h(!0);
    const t = L ? m.length === 2 : m.length === 0, s = Ue(L, C, t);
    let o;
    const i = Fe(C);
    C.length && i ? o = [{ type: "text", text: i }] : o = e;
    const ee = {
      id: `${Date.now().toString()}-${u(4)}-1`,
      role: "user",
      content: o,
      metadata: s
    }, E = [...m.length ? [] : X, ee];
    d && re(), l((I) => [...I, ...E]), r.current = [...r.current, ...E], w([]), x(""), $(
      {
        eventName: "user_message_submitted",
        properties: {}
      },
      r.current
    );
    const te = [je, ...ge?.({ conversation: U }) || []];
    try {
      const I = {
        model: de,
        messages: r.current,
        stream: !0,
        tools: te,
        tool_choice: "auto"
      }, se = await le(), ne = se ? btoa(JSON.stringify(se)) : null, oe = J || H ? JSON.stringify({
        ...J,
        ...H
      }) : void 0, N = {};
      !W && ne && (N["X-INKEEP-CHALLENGE-SOLUTION"] = ne), oe && (N["inkeep-filters"] = oe);
      const g = ue.beta.chat.completions.stream(
        I,
        Object.keys(N).length > 0 ? { headers: N } : void 0
      ), n = {
        id: `${Date.now().toString()}-${u(4)}-2`,
        role: "assistant",
        content: "",
        links: [],
        toolCalls: []
      };
      l((_) => [..._, n]), g.on("content", (_, M) => {
        y(!0), n.content = M, l((A) => {
          const a = [...A], O = a.findIndex((S) => S.id === n.id);
          return O === -1 ? [...a, n] : (a[O] = { ...n }, a);
        });
      }), g.on("tool_calls.function.arguments.done", (_) => {
        const { name: M, arguments: A } = _, a = te?.find((p) => p.function.name === M);
        if (!a) return;
        const S = ("parse" in a.function ? a.function.parse : JSON.parse)(A), _e = a.function.function?.(S, g), Ae = a.renderMessageButtons?.({ args: S, execution: _e }) ?? [];
        M === "provideLinks" ? n.links = S.links ?? [] : V((p) => ({
          ...p,
          [n.id]: [...p[n.id] ?? [], ...Ae]
        })), n.toolCalls?.push({
          id: "call_" + u(24),
          type: "function",
          function: {
            name: M,
            arguments: A
          }
        }), l((p) => {
          const R = [...p], xe = R.findIndex((Le) => Le.id === n.id);
          return R[xe] = { ...n }, R;
        });
      }), g.on("error", Y), g.finalChatCompletion().then(() => {
        r.current = [...r.current, n], v.current = null, h(!1), y(!1), b(), $(
          {
            eventName: "assistant_message_received",
            properties: {}
          },
          r.current
        );
      }), v.current = g.controller;
    } catch (I) {
      Y(I), h(!1), y(!1);
    }
  }, ke = () => {
    v.current && (v.current.abort(), v.current = null), h(!1), y(!1), b();
  }, Z = () => {
    q(null), l([]), r.current = [], ce(), V({}), w([]), re(), G(null), z(), b(), $({
      eventName: "chat_clear_button_clicked",
      properties: {
        conversation: U
      }
    });
  }, be = (e) => {
    G(e);
    const { initialReplyMessage: t, displayName: s } = e, o = {
      id: m.length.toString() + u(4),
      role: "user",
      content: s
    }, i = {
      id: (m.length + 1).toString() + u(4),
      role: "assistant",
      content: t,
      links: []
    }, E = [{
      id: `system-${Date.now().toString()}-${u(4)}-${e.id}`,
      role: "system",
      content: `Company has asked user to follow this guided workflow:
${Ke(e)}`
    }, ...X, o, i];
    l(E), w([]);
  }, { openForm: $e } = Je(), Ee = Te();
  De(F.chatFunctionsRef, () => ({
    submitMessage: D,
    updateInputMessage(e) {
      x(e);
    },
    clearChat: Z,
    openForm: (e) => {
      Ee?.setView("chat"), $e(e);
    },
    focusInput: () => {
      Q.current?.focus();
    }
  }));
  const Ne = ze("(max-width: 768px)");
  return {
    messages: m,
    input: f,
    isLoading: j,
    isStreaming: fe,
    isLoadingConversation: we,
    error: he,
    isSubmitDisabled: B,
    handleInputChange: Se,
    handleInputKeyDown: Me,
    handleSubmit: D,
    stop: ke,
    clear: Z,
    handleWorkflow: be,
    selectedWorkflow: L,
    messageAttachments: C,
    setMessageAttachments: w,
    addAttachment: ye,
    messageButtons: Ce,
    isEmpty: m.length === 0,
    inputRef: Q,
    isMobile: Ne
  };
};
export {
  mt as useInkeepChat
};
